import HealthsFilterTab from './HealthsFilterTab';

export default HealthsFilterTab;



// WEBPACK FOOTER //
// ./src/components/App/ClientListWithMap/HealthsFilterTab/index.js